import type { OrganizationModuleSummary } from '@A/controllers/modules.api'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

/**
 * Holds the modules the current organization is subscribed to.
 */
export const useModulesStore = defineStore('modules', () => {
  const subscribedModules = ref<OrganizationModuleSummary[]>([])
  const loaded = ref(false)
  const loading = ref(false)

  const subscribedCommonIds = computed(() => new Set(subscribedModules.value.map((m) => m.common_id)))

  const setModules = (modules: OrganizationModuleSummary[]): void => {
    subscribedModules.value = modules
    loaded.value = true
  }

  const setLoading = (value: boolean): void => {
    loading.value = value
  }

  const clear = (): void => {
    subscribedModules.value = []
    loaded.value = false
  }

  const hasModuleAccess = (commonId: string): boolean => {
    return subscribedCommonIds.value.has(commonId)
  }

  return {
    subscribedModules,
    subscribedCommonIds,
    loaded,
    loading,
    setModules,
    setLoading,
    clear,
    hasModuleAccess
  }
})
